import React  , { Component } from 'react'

import {  HomeSlider,
          HomeDeals,
          VideoSliderItem,
          PostSliderItem,
          HomeTitle ,
          CoverSection         } from '../../Components/UI/UI'

import {    newPosts  } from "../../Data/Data";
import { getWeather, asyncgetWeather } from "../../Utility/Utility";
import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "../innerPage.css"
import "./ThingsToDo.css"

class ThingsToDo extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  componentDidMount() {
    Promise.all([asyncgetWeather()]).then((response) => {
        var weather = response[0];
     

    
        // console.log(typeof weather);
        // console.log( weather);

        const jerusalemTemperature = '20';
        const deadSeaTemperature = '20';
        const telAvivTemperature = '20';
        const telAvivWaterTemp = '20';

        if (typeof weather !== 'object') {
            // console.log('The weather variable is a string.');
            
            // Find the starting index of the JSON object
            const jsonStartIndex = weather.indexOf('{"jerusalem"');
    
            if (jsonStartIndex !== -1) {
                  // Extract the JSON substring
                  const jsonString = weather.substring(jsonStartIndex);
      
                  // Log the extracted JSON string to verify
                  // console.log('Extracted JSON String:', jsonString);
      
                  try {
                      const weatherData = JSON.parse(jsonString);
                      // console.log('Parsed Weather Data:', weatherData);
      
                      // Accessing the required temperature values
                      const jerusalemTemperature = weatherData.jerusalem.temperature;
                      const deadSeaTemperature = weatherData.deadsea.temperature;
                      const telAvivTemperature = weatherData.telaviv.temperature;
                      const telAvivWaterTemp = weatherData.telaviv.water_temp;
      
                      // console.log('Jerusalem Temperature:', jerusalemTemperature);
                      // console.log('Dead Sea Temperature:', deadSeaTemperature);
                      // console.log('Tel Aviv Temperature:', telAvivTemperature);
                      // console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
      
                      // Set the state with the extracted values
                      this.setState({
                        
                          jerusalemWeather: jerusalemTemperature,
                          deadSeaWeather: deadSeaTemperature,
                          telAvivWeather: telAvivTemperature,
                          waterTemp: telAvivWaterTemp,
                      });
      
                  } catch (error) {
                      console.error('Error parsing JSON:', error);
                  }
              } else {
                  console.error('No JSON found in the weather response');
                  this.setState({
                    jerusalemWeather: jerusalemTemperature,
                    deadSeaWeather: deadSeaTemperature,
                    telAvivWeather: telAvivTemperature,
                    waterTemp: telAvivWaterTemp,
                });
              }
        } else {
            // console.log('The weather variable is an object.');
            this.setState({
                jerusalemWeather: weather.jerusalem.temperature,
                deadSeaWeather: weather.deadsea.temperature,
                telAvivWeather: weather.telaviv.temperature,
                waterTemp: weather.jerusalem.water_temp,
            });
        }

    });

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateDimensions);
}
  


  render(){
    // get all posts 
    const  posts = [ ...newPosts ] ;

    // get non video posts and culinary posts
    const nonVidPosts = posts.filter((o , i )=>{
      // return  o.isVid === false  || o.ctg === 'culinary' || o.isDouble === true;

         return  o.ctg === 'culinary' || o.ctg === 'jerusalem' || o.ctg === 'telaviv' || o.ctg === 'deadsea' || o.ctg === 'deadsea_2' || o.ctg === 'telavivAndJerusalem';
    })

    const thingsToDoPosts = [ ...posts ];

    //  const thingsToDoPosts = posts.filter((o , i )=>{
    //   return (o.isDouble == false);


    // })


    const postsHtml = thingsToDoPosts.map( (o,i) => {
        // console.log('o' , o);
        let cssClass="";
        let html ="";
        if ( i % 4 === 0 ) {
          cssClass =" first";
        }
        let url = null;
        let component = null;

       

              if (o.isVid === true) {
         
                url  = "/Posts/Videos/" + o.ctg  + '/' + o.id;
                component = <VideoSliderItem  
                              key={i}
                              title={o.title}
                              desc={""}
                              img= {o.img}
                              link={url}
                              cssClass={cssClass} />
              }else {
                // url = "/Posts/" + o.id ;
                url  = "/Posts/" + o.ctg  + '/' + o.id;
                component = <PostSliderItem  
                                key={i}
                                title={o.title}
                                desc={""}
                                img= {o.img}
                                link={url}
                                cssClass={cssClass} />
              }

    
        
        

        return component;
        
    });

    return(
      <div className="inner-page align-center page-ExporeTelAvivAndJerusalem page-thingsToDo">
        <Menu />
       {/*<HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />*/}
         <CoverSection desktopImg={'/posts/bank/page-thingstodo/1.jpg'} mobileImg={'/posts/bank/page-thingstodo/M.jpg'} cssClass={'jerusalim'} waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather}/>
        
        <section className="live-shows-section">
          <div className="container">
            <HomeTitle>
              ERLEBEN
            </HomeTitle>
            <div className="live-shows-wrapper">
              {postsHtml}
              
            </div>
            <HomeDeals />
          </div>
        </section>
        <Footer />
      </div>
    )
  }

}



export default ThingsToDo


// WEBPACK FOOTER //
// ./src/Pages/ThingsToDo/ThingsToDo.js